<template>
  <div
      class="be-form-group"
      :class="!!error && 'be-form-error'"
  >
    <label
        v-if="label"
        :for="name"
        class="be-form-label"
    >
      {{label}}
      <span v-if="required" class="required">*</span>
    </label>

    <div class="be-form-control--wrapper" :class="{'before': !!$slots.before, 'after': !!$slots.after}">
      <div v-if="!!$slots.before" class="be-form-control--before"><slot name="before"></slot></div>
      <div v-if="!!$slots.after" class="be-form-control--after"><slot name="after"></slot></div>
      <template v-if="type === 'textarea'">
        <textarea
            :disabled="disabled"
            :id="name"
            :name="name"
            :value="value"
            :class="!!error && !!isKeyPress && 'be-form-control--error'"
            class="be-form-control"
            @input="onInput($event.target.value)"
            @blur="onBlur"
        />
      </template>
      <template v-else-if="type === 'button'">
        <input
            :disabled="disabled"
            :id="name"
            :name="name"
            readonly
            type="text"
            :placeholder="placeholder"
            :value="value"
            :class="!!error && !!isKeyPress && 'be-form-control--error'"
            class="be-form-control"
            @click="$emit('click')"
        />
      </template>
      <template v-else>
        <input
            :disabled="disabled"
            :id="name"
            :name="name"
            :type="type"
            :value="value"
            :placeholder="placeholder"
            :class="!!error && !!isKeyPress && 'be-form-control--error'"
            class="be-form-control"
            @input="onInput($event.target.value)"
            @blur="onBlur"
        />
        <span
            v-if="passwordSwitcher"
            :class="type === 'text' ? 'show' : ''"
            class="be-form--password-switch"
            @click="onSwitch"
        ><i class="icon-be-eye"/></span>
      </template>
    </div>

    <p v-if="!!error" class="be-form-control--text-error">
      {{ error }}
    </p>
    <p v-if="!!info" class="be-form-control--text">
      {{ info }}
    </p>
    <p v-if="!!success" class="be-form-control--text-success">
      {{ success }} <i class="icon-be-check"/>
    </p>
  </div>
</template>

<script>
export default {
  name: "BeInput",
  props: {
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    error: {
      type: String,
      required: false
    },
    info: {
      type: String,
      required: false
    },
    success: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    passwordSwitcher: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isKeyPress: false
    };
  },
  watch: {
    value() {
      if(this.error) {
        this.$emit('validate')
      }
    }
  },
  methods: {
    onSwitch() {
      this.$emit('switch')
    },
    onInput(value) {
      this.$emit("input", value);
      if (this.isKeyPress) {
        this.isKeyPress = false;
      }
    },
    onBlur() {
      this.isKeyPress = true;
      this.$emit("validate");
    }
  }
};
</script>
